<template>
  <div class="verify-card">
    <div class="verify-bar"></div>

    <!-- ICON -->
    <div class="verify-icon" :class="status">
      <template v-if="status === 'pending'">
        <img src="../../assets/images/svg-icon/shield.svg" height="32" />
      </template>

      <template v-else-if="status === 'success'">
        <div class="success-icon">✓</div>
      </template>

      <template v-else>
        <div class="error-icon">!</div>
      </template>
    </div>

    <!-- ===== PENDING ===== -->
    <template v-if="status === 'pending'">
      <h2>Verifica tu cuenta</h2>
      <p class="text-muted">
        Te enviamos un código a tu correo<br />
        <strong>{{ email }}</strong>
      </p>

      <div class="code-inputs">
        <input v-for="(digit, i) in codeDigits" :key="i" maxlength="1" class="code-input" v-model="codeDigits[i]"
          @input="handleInput(i, $event)" @keydown.backspace="handleBackspace(i)" :ref="el => setInputRef(el, i)" />
      </div>

      <button class="btn btn-primary btn-lg w-100 mt-4" @click="verifyCode" :disabled="!isCodeComplete">
        Verificar cuenta
      </button>


      <p class="resend mt-4" v-if="hasSentCode">
        ¿No recibiste el código?
        <a href="javascript:void(0)" @click="$emit('resend')">Reenviar código</a>
      </p>
      <p class="resend mt-4" v-else>
        Código enviado. Revisa tu correo y sigue las instrucciones para activar tu cuenta.
      </p>
    </template>

    <!-- ===== SUCCESS ===== -->
    <template v-else-if="status === 'success'">
      <h2>¡Cuenta verificada!</h2>
      <p class="text-muted">
        Tu cuenta ha sido activada con éxito.<br />
        Ya puedes comenzar a gestionar tus CFDIs.
      </p>

      <button class="btn btn-primary btn-lg w-100 mt-4" @click="$emit('dashboard')">
        Ir a tusCFDIs
      </button>

    </template>

    <!-- ===== ERROR ===== -->
    <template v-else>
      <h2>Código incorrecto</h2>
      <p class="text-muted">
        El código ingresado no es válido o ha expirado.<br />
        Intenta nuevamente o solicita uno nuevo.
      </p>

      <button class="btn btn-primary btn-lg w-100 mt-4" @click="retry">
        Reintentar verificación
      </button>

      <p class="resend mt-3">
        ¿No recibiste el código?
        <a href="javascript:void(0)" @click="$emit('resend')">Reenviar código</a>
      </p>
    </template>

  </div>
</template>

<script>
export default {
  name: 'VerifyStatusCard',
  props: {
    email: {
      type: String,
      default: ''
    },
    status: {
      type: String,
      default: 'pending' // pending | success | error
    },
    hasSentCode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      codeDigits: ['', '', '', '', '', ''],
      inputRefs: []
    }
  },
  computed: {
    isCodeComplete() {
      return this.codeDigits.every(d => d !== '')
    }
  },

  methods: {
    setInputRef(el, index) {
      if (el) {
        this.inputRefs[index] = el
      }
    },
    handleInput(index, event) {
      const value = event.target.value

      // Solo permitir alfanumérico
      if (!/^[a-zA-Z0-9]$/.test(value)) {
        this.codeDigits[index] = ''
        return
      }

      // Convertir a mayúscula si quieres consistencia
      this.codeDigits[index] = value.toUpperCase()

      // Mover al siguiente input
      if (index < this.codeDigits.length - 1) {
        this.inputRefs[index + 1]?.focus()
      }
    },

    handleBackspace(index) {
      if (this.codeDigits[index] === '' && index > 0) {
        this.inputRefs[index - 1]?.focus()
      }
    },
    verifyCode() {
      const code = this.codeDigits.join('')
      this.$emit('verify', code)
    },
    retry() {
      this.codeDigits = ['', '', '', '', '', ''];
      this.$emit('retry')
    }
  }
};
</script>
